<loading-animation [message]="message" size="{{ size }}" [requestContext]="requestContext"></loading-animation>
